import React, {useState} from "react"

import {FieldTableCellProps} from "../../../../../render/table/table-cell"
import FieldFormula_TableCellCalculated_NotHovered from "./not-hovered"
import FieldFormula_TableCellCalculated_Hovered from "./hovered"

// const debug = "FieldFormula_TableCellCalculated"
const debug = false

export default function FieldFormula_TableCellCalculated(props: FieldTableCellProps) {

    const [isHovered, setIsHovered]     = useState(false)

    const onMouseEnter = () => {
        setIsHovered(true)
    }

    const onMouseLeave = () => {
        setIsHovered(false)
    }


    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered) {
        return (
            <FieldFormula_TableCellCalculated_Hovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    } else {
        return (
            <FieldFormula_TableCellCalculated_NotHovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    }
}
